<div class="main-db gap-top">
    <div class="container-fluid mt-2">
      <div class="row">
        <div class="col-12 col-sm-10">
          <h1>{{ title }}</h1>
        </div>
      </div>
      <div class="row">
        <div class="col-12 mt-2">
          <div class="table-responsive db-block" style="height: auto !important">
            <i class="fa fa-database mr-2" aria-hidden="true"></i>
            <span>{{ "Event Details" }}</span>
            <table mat-table [dataSource]="dataSource" class="gridData mt-2" matSort>

                <ng-container matColumnDef="eventName">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Event Name</th>
                    <td mat-cell *matCellDef="let element">{{ element.eventName }}</td>
                </ng-container>

                <ng-container matColumnDef="phoneNumber">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Contact</th>
                    <td mat-cell *matCellDef="let element">{{ element.phoneNumber }}</td>
                </ng-container>

                <ng-container matColumnDef="startDate">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Start Date</th>
                    <td mat-cell *matCellDef="let element">{{ element.startDate | date : "y-MM-dd" }}</td>
                </ng-container>

                <ng-container matColumnDef="endDate">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>End Date</th>
                    <td mat-cell *matCellDef="let element">{{ element.endDate | date : "y-MM-dd" }}</td>
                </ng-container>

                <ng-container matColumnDef="noOfExpectedGuest">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Guests</th>
                    <td mat-cell *matCellDef="let element">{{ element.noOfExpectedGuest }}</td>
                </ng-container>

                <ng-container matColumnDef="noOfRegisteredVehicles">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Reg. Vehicles</th>
                    <td mat-cell *matCellDef="let element">{{ element.noOfRegisteredVehicles }}</td>
                </ng-container>

                <ng-container matColumnDef="noOfVolunteersRequired">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Volunteers</th>
                    <td mat-cell *matCellDef="let element">{{ element.noOfVolunteersRequired }}</td>
                </ng-container>

                <ng-container matColumnDef="actions">
                    <th mat-header-cell *matHeaderCellDef>Action</th>
                    <td mat-cell *matCellDef="let element">
                      <button mat-icon-button matTooltip="Click to View Details" class="iconbutton text-warning float-left">
                        <mat-icon aria-label="View" (click)="eventPeoDetail(element)">remove_red_eye</mat-icon>
                      </button>
                        <button (click)="addPeoDialog(element)" class="btn btn-sm btn-success" data-toggle="modal" data-target="#addPeoPrompt">
                          <i class="fas fa-plus-circle mr-2"></i>Add PEO</button>

                        <!-- The Modal -->
                        <div class="modal fade" id="addPeoPrompt" tabindex="-2" role="dialog" aria-labelledby="deletePromptLabel" aria-hidden="true">
                          <div class="modal-dialog" role="document">
                            <div class="modal-content">
                              <div class="modal-header">
                                <h5 class="modal-title orange-text" id="deletePromptLabel">Add PEO</h5>
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                  <span aria-hidden="true">&times;</span>
                                </button>
                                </div>
                                <div class="modal-body">
                                  <select [(ngModel)]="selectedPeoId" class="form-control form-control-sm input-custom">
                                    <option value="0" selected disabled >Select PEO</option>
                                    <option *ngFor="let peo of allPeoData" value={{peo.userId}}>{{peo.firstName + ' ' +peo.lastName}}</option>
                                </select>
                                </div>
                                <div class="modal-footer">
                                <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                                <button type="button" class="btn btn-success" data-dismiss="modal" (click)="linkPeoWithEvent()">Add</button>
                              </div>
                            </div>
                          </div>
                        </div>

                    </td>
                </ng-container>
    
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
            </table>
          </div>
          <mat-paginator [pageSizeOptions]="[10, 25, 100]"></mat-paginator>
        </div>
      </div>

    </div>
  </div>
  